import { render } from "./ExpireItem.vue?vue&type=template&id=53191421"
import script from "./ExpireItem.vue?vue&type=script&lang=js"
export * from "./ExpireItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__